module.exports = __webpack_public_path__ + "img/monitor_title.b1fad1e5.svg";